// adapted from https://overreacted.io/making-setinterval-declarative-with-react-hooks/

import { useEffect, useRef } from "react";

export function useInterval<F extends (...args: any[]) => any>(
  callback: F,
  delay: number,
): void {
  const savedCallback = useRef<F>();

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval. We only want to do this when the delay changes
  // because if this fires too often the function will never get called
  useEffect(() => {
    function tick(): void {
      savedCallback.current && savedCallback.current();
    }
    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
}
